import React, { useContext } from 'react';

import { useRouter } from 'next/router';

import { AppContext } from '../../../../context';

import Style from './NewUserOptions.module.css';

import { Button } from '../../../atoms';

function NewUserOptions() {
  const { isMobile } = useContext(AppContext);
  const router = useRouter();

  const handleClick = (val) => {
    // checking for redirect_url in sessionStorage to handle continue application event

    const redirect_url = sessionStorage.getItem('redirect_url');
    const jobId = sessionStorage.getItem('jobId');

    sessionStorage.removeItem('redirect_url');
    sessionStorage.removeItem('jobId');

    if (val === 'dashboard') {
      router.push('/jobs/explore');
    } else {
      sessionStorage.setItem('application_open', true);

      if (isMobile) {
        router.push(redirect_url);
      } else {
        if (redirect_url.includes('jobId')) {
          const searchParams = new URLSearchParams('?' + redirect_url.split('?')?.[1]);

          searchParams.set('jobId', jobId);
          const newurl = redirect_url.split('?')?.[0] + '?' + searchParams.toString();

          router.push(newurl);
        } else if (redirect_url.split('?')?.[1]) {
          router.push(`${redirect_url}&jobId=${jobId}`);
        } else {
          router.push(`${redirect_url}?jobId=${jobId}`);
        }
      }
    }
  };

  return (
    <>
      {isMobile ? (
        <div className={Style.NewUserOptionsContainer}>
          <div className={Style.ExpertLogo}>
            <img src='/images/login/logo.svg' />
          </div>
          <div className={Style.OptionContainer}>
            <img src='/images/login/dashboard.svg' />
            <Button className='general-outline-style' onClick={() => handleClick('dashboard')}>
              My Dashboard
            </Button>
          </div>
          <div className={Style.OptionContainer}>
            <img src='/images/login/application.svg' />
            <Button className='general-outline-style' onClick={() => handleClick('application')}>
              Continue Application
            </Button>
          </div>
        </div>
      ) : (
        <div className={Style.NewUserOptionsContainer}>
          <div className={Style.ExpertLogo}>
            <img src='/images/login/logo.svg' />
          </div>
          <div className={Style.OptionContainer}>
            <img src='/images/login/dashboard.svg' />
            <Button className='general-outline-style' onClick={() => handleClick('dashboard')}>
              My Dashboard
            </Button>
          </div>
          <div className={Style.OptionContainer}>
            <img src='/images/login/application.svg' />
            <Button className='general-outline-style' onClick={() => handleClick('application')}>
              Continue Application
            </Button>
          </div>
        </div>
      )}
    </>
  );
}

export default NewUserOptions;
